import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../../components/AdminModal';
import useToast from '../../../../customHooks/useToast';
import { ADMIN_EDIT_ROLES } from '../../../../graphql/admin_mutations';
// import ModalFormComp from '../../../../components/ModalFormComp';

import RoundMinusIcon from '../../../../svgs/RoundMinusIcon';
import Styles from './DeactivateRole.module.scss';

interface IDeactivateRole{
  onClose:any;
  payload:any;
  refetch:any;
}
const DeactivateRole = ({ onClose, payload, refetch }:IDeactivateRole) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [editRoles, { loading: editRolesLoading }] = useMutation<
  { updateRole: any },
  any
  >(ADMIN_EDIT_ROLES);

  const activateAndDeactivateRole = async () => {
    const data = {
      input: {
        display_name: payload?.display_name,
        is_active: false,
        name: payload?.name,
      },
      updateRoleRoleId2: payload?.id,
    };
    if (!editRolesLoading) {
      try {
        const res = await editRoles({
          variables: data,
        });

        if (res?.data?.updateRole && res?.data?.updateRole?.status === 200) {
          refetch?.('deactivate');
          setIsSuccessful(true);
        } else {
          Toast.error(res?.data?.updateRole?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Role Deactivated!' : 'Are you sure you want to deactivate this role?'}
        subText={isSuccessful ? `${payload?.name} has been deactivated successfully.` : 'By clicking on “Deactivate Role”, all users assigned to the role will be deactivated. If you are not sure, please cancel.'}
        actionBtnName="Yes, deactivate"
        handleModalAction={activateAndDeactivateRole}
        topIcon={<div className={Styles.wrapper__icon}><RoundMinusIcon /></div>}
        isShow
        isActionBtnDisabled={editRolesLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={editRolesLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      />
    </div>
  );
};

export default DeactivateRole;
